export default __webpack_public_path__ + "static/media/at-rail-terminal-on-train.e001e655.svg";